import phone from 'phone';
import { isEmailValid } from 'functions/isEmailValid';

const minLength = (min, errorMessage) => (val) => val.trim().length >= min || errorMessage;
const maxLength = (max, errorMessage) => (val) => val.length <= max || errorMessage;
const required = (errorMessage) => (val) => val.trim() !== '' || errorMessage;
const validEmail = (errorMessage) => (val) => isEmailValid(val) || errorMessage;
const validPhone = (errorMessage) => (val) => {
  const result = phone(val);
  return result.isValid || errorMessage;
};

export {
  minLength,
  maxLength,
  required,
  validEmail,
  validPhone,
};
